<template>
    <div class="md:grid md:grid-cols-12 md:gap-6">
        <div class="sm:col-span-12">
            <div class="mt-1">
                <FormLabel :value="''" for="yes_no"> ({{ $t('messages.yes') }} / {{ $t('messages.no') }}) </FormLabel>
                <input
                    name="selected"
                    v-model="form.yes_no"
                    id="yes_no"
                    type="checkbox"
                    class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                />
            </div>
        </div>

        <div class="sm:col-span-12">
            <div class="mt-1">
                <FormLabel :value="form.yes_no ? $t('messages.yes') : $t('messages.true')" :for="`true`">
                    <CorrectIncorrectIcon :is-correct="form.answer === 'TRUE'" />
                    <div class="mt-1 inline-block">
                        <label>
                            <input
                                name="is_correct"
                                type="radio"
                                :id="`option_is_correct_true`"
                                :value="`TRUE`"
                                v-model="form.answer"
                                class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                            />
                            {{ $t('messages.is_correct') }}
                        </label>
                    </div>
                </FormLabel>
            </div>
        </div>

        <div class="sm:col-span-12">
            <div class="mt-1">
                <FormLabel :value="form.yes_no ? $t('messages.no') : $t('messages.false')" :for="`false`">
                    <CorrectIncorrectIcon :is-correct="form.answer === 'FALSE'" />
                    <div class="mt-1 inline-block">
                        <label>
                            <input
                                name="is_correct"
                                type="radio"
                                :id="`option_is_correct_false`"
                                :value="`FALSE`"
                                v-model="form.answer"
                                class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                            />
                            {{ $t('messages.is_correct') }}
                        </label>
                    </div>
                </FormLabel>
            </div>
        </div>
    </div>
</template>

<script>
import FormLabel from '@/components/Forms/FormLabel.vue';
import CorrectIncorrectIcon from '@/components/Quiz/CorrectIncorrectIcon.vue';

export default {
    name: 'QuestionTrueFalseOptions',
    components: {
        FormLabel,
        CorrectIncorrectIcon,
    },
    props: {
        modelValue: {
            required: true,
        },
        errors: {
            required: true,
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            form: this.modelValue,
        };
    },
    watch: {
        answer(newVal) {
            this.$emit('update:modelValue', newVal);
        },
    },
    methods: {},
    mounted() {
        if (!this.form.hasOwnProperty('answer')) {
            this.form['answer'] = 'TRUE';
            this.form['yes_no'] = false;
        }
    },
};
</script>
